export default "<div class=\"loading-shade\">\r\n    <mat-spinner></mat-spinner>\r\n</div>";